import { ComponentType, ForwardedRef, forwardRef, HTMLAttributes } from "react";
import {
  Button,
  Menu,
  MenuButton,
  MenuButtonProps,
  MenuList,
  MenuProps,
  IconProps,
  ButtonProps,
  Portal,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";

export function DropDownButtonIcon() {
  return <ChevronDownIcon boxSize="1.25em" />;
}

type Props = MenuProps & {
  LeftIconComponent?: React.ComponentType<IconProps> | null;
  RightIconComponent?: React.ComponentType<IconProps> | null;
  buttonAs?: ComponentType<HTMLAttributes<HTMLButtonElement>>;
  buttonLabel?: React.ReactNode;
  buttonProps?: MenuButtonProps & ButtonProps;
  children: React.ReactNode;
  isDisabled?: boolean;
  isMenuInPortal?: boolean;
};

function DropDownMenuInner(
  {
    LeftIconComponent,
    RightIconComponent,
    buttonAs = Button,
    buttonLabel,
    buttonProps,
    children,
    isDisabled,
    isMenuInPortal,
    ...rest
  }: Props,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  const menuList = <MenuList>{children}</MenuList>;
  return (
    <Menu {...rest}>
      {({ isOpen }) => (
        <>
          <MenuButton
            ref={ref}
            size="xs"
            isActive={isOpen}
            as={buttonAs}
            leftIcon={
              LeftIconComponent && <LeftIconComponent boxSize=".75em" />
            }
            rightIcon={
              (RightIconComponent && <RightIconComponent boxSize=".75em" />) ||
              (RightIconComponent === undefined && <DropDownButtonIcon />)
            }
            isDisabled={isDisabled}
            {...buttonProps}
          >
            {buttonLabel}
          </MenuButton>

          {isMenuInPortal ? <Portal>{menuList}</Portal> : menuList}
        </>
      )}
    </Menu>
  );
}

export default forwardRef(DropDownMenuInner);
